<script setup lang="ts">
import { computed } from 'vue';
import { BoulderModel } from '../../../core/boulder_model';
import LineThumbnailView from './line_thumbnail_view.vue';

const props = defineProps<{ boulder: BoulderModel }>();
const boulder = computed(() => { return props.boulder; });
</script>

<template>
    <div v-if="(boulder.lines?.length || 0) > 0">
        <h3>Lines</h3>
        <div class='thumbnails-container'>
            <LineThumbnailView v-for="line of boulder.lines" v-bind:line="line"></LineThumbnailView>
        </div>
    </div>
</template>
